export class AwsEksClusterResource {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "clusterName",
            "baseName": "clusterName",
            "type": "string",
            "format": ""
        },
        {
            "name": "clusterArn",
            "baseName": "clusterArn",
            "type": "string",
            "format": ""
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "string",
            "format": ""
        },
        {
            "name": "kubernetesVersion",
            "baseName": "kubernetesVersion",
            "type": "string",
            "format": ""
        },
        {
            "name": "endpoint",
            "baseName": "endpoint",
            "type": "string",
            "format": ""
        },
        {
            "name": "platformVersion",
            "baseName": "platformVersion",
            "type": "string",
            "format": ""
        },
        {
            "name": "vpcId",
            "baseName": "vpcId",
            "type": "string",
            "format": ""
        },
        {
            "name": "subnetIds",
            "baseName": "subnetIds",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "securityGroupIds",
            "baseName": "securityGroupIds",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "authenticationMode",
            "baseName": "authenticationMode",
            "type": "string",
            "format": ""
        },
        {
            "name": "encryptionAtRestEnabled",
            "baseName": "encryptionAtRestEnabled",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "kmsKeyArn",
            "baseName": "kmsKeyArn",
            "type": "string",
            "format": ""
        },
        {
            "name": "nodeGroupCount",
            "baseName": "nodeGroupCount",
            "type": "number",
            "format": ""
        },
        {
            "name": "fargateProfileCount",
            "baseName": "fargateProfileCount",
            "type": "number",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AwsEksClusterResource.attributeTypeMap;
    }
    constructor() {
    }
}
